import Rails from "@rails/ujs"
import { Controller } from "stimulus"
import { showOverlay, hideOverlay, scrollToFirstError } from '../services/form_helper'

export default class extends Controller {
  static targets = ['form','smokingNumber','addButton'];
  static classes = ['errorm','hide'];
  static values = {validateurl: String, uploadurl: String, removeimageurl: String, addimagefieldurl: String};

  formTargetConnected() {
    this.toggleSmokingNumberInput();
    const index = document.getElementById("image_index");
    this.removeAddButton(Number(index.value));
  }

  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
      if(errorM == undefined){
        errorM = pa.parentElement.parentElement.querySelector("."+this.errormClass);
      }
    }
    const formData = new FormData(this.formTarget);
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }


  addUploadField(){
    const uploadField = document.getElementById("diagnostic_image_upload_field");
    const formData = new FormData(this.formTarget);
    const index = document.getElementById("image_index");
    formData.append("index",index.value);
    formData.append("jsc","reservation-interview");
    Rails.ajax({
      url: this.addimagefieldurlValue,
      type: "POST",
      dataType: 'html',
      data: formData,
      success: (response) => {
        console.log(response.body);
        uploadField.innerHTML = response.body.innerHTML;
      }
    });
    this.removeAddButton(Number(index.value)+1);
  }

  autoUpload(event){
    const el = event.currentTarget;
    const params = event.params;
    const targetName = params.targetname;
    const index = params.index;
    if(el.value != null && el.value != ""){
      const formData = new FormData(this.formTarget);
      formData.append("type",targetName);
      formData.append("index",index);
      Rails.ajax({
        url: this.uploadurlValue,
        type: "POST",
        dataType: 'json',
        data: formData,
        success: (response) => {
          if(response.error != null){
            document.getElementById("diagnostic_images_"+targetName+"_error_message").textContent = response.error;
          }else {
            const viewDiv = document.getElementById("image_view_" + targetName);
            const image = viewDiv.querySelector("img");
            image.src = response.image_url;
            viewDiv.classList.remove(this.hideClass);
            document.getElementById("image_upload_" + targetName).classList.add(this.hideClass);
            document.getElementById("diagnostic_images_id_" + index).value = response.di_id;
            document.getElementById("diagnostic_images_" + targetName + "_error_message").textContent = "";
          }
        }
      });
    }
  }

  removeImage(event){
    const params = event.params;
    const targetName = params.targetname;
    const formData = new FormData(this.formTarget);
    const index = params.index;
    formData.append("type",targetName);
    formData.append("index",index);
    Rails.ajax({
      url: this.removeimageurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response) => {
        console.log(response);
        const viewDiv = document.getElementById("image_view_"+targetName);
        const image = viewDiv.querySelector("img");
        image.src = "";
        viewDiv.classList.add(this.hideClass);
        document.getElementById("diagnostic_images_id_"+index).value = null;
        document.getElementById("image_upload_"+targetName).classList.remove(this.hideClass);
      }
    });
  }

  validateAll(){
    showOverlay();
    let errorMs = document.querySelectorAll("."+this.errormClass);
    const formData = new FormData(this.formTarget);
    const allErrorE = document.getElementById("allError");
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        if(Object.keys(response).length > 0){
          let allErrorTxt = "";
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
                allErrorTxt += response[key]+"<br />";
              }
            })
          });
          allErrorE.innerHTML = allErrorTxt;
          allErrorE.classList.remove(this.hideClass);
          hideOverlay();
          scrollToFirstError(this.errormClass);
        }else{
          allErrorE.innerHTML = '';
          allErrorE.classList.add(this.hideClass);
          this.formTarget.submit();
        }
      }
    });
  }

  checkboxDisable(event){
    const el = event.currentTarget;
    const selectors = document.getElementsByName(el.name);
    if(el.checked == true){
      selectors.forEach(function(s){
        s.checked = false;
        s.disabled = true;
      });
      el.checked = true;
      el.disabled = false;
    }else{
      selectors.forEach(function(s){
        s.disabled = false;
      });
    }
  }

  toggleSmokingNumberInput(){
    const form = this.formTarget;
    const smoking = form.querySelector("input[name='diagnostic[smoking]']:checked");
    if(smoking != undefined){
      if(smoking.value == "not"){
        this.smokingNumberTarget.classList.add(this.hideClass);
      }else{
        this.smokingNumberTarget.classList.remove(this.hideClass);
      }
    }
  }

  removeAddButton(index){
    if(index >= 2){
      this.addButtonTarget.classList.add('is-hidden')
    }
  }
}
